import { Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ChatPage from './pages/ChatPage';
import ProtectedRoute from './components/ProtectedRoute';
import LoadingBar from './components/LoadingBar';

export default function App() {
  return (
    <>
      {/* F-005: skip-link so keyboard / screen-reader users can jump past
          the app chrome straight to the chat surface. Hidden until focused
          (see .skip-link in styles/index.css). The matching target lives on
          the <main> element inside ChatPage. */}
      <a href="#main-content" className="skip-link">
        Skip to messages
      </a>
      <LoadingBar />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route
          path="/c/:conversationId"
          element={
            <ProtectedRoute>
              <ChatPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <ChatPage />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
